/**
 * Company: SPHMedia
 * Description: [Brief description of the component]
 */

import clsx from "clsx";
import { useLocation } from "react-router";

interface NextButtonProps {
  currentPage: number;
  loading: boolean;
  onNext: () => void;
  className?: string;
  text?: string;
  hasMore?: boolean;
}

export default function NextButton({
  currentPage,
  loading,
  onNext,
  className = "m-auto block text-center",
  text = "next",
  hasMore = true,
}: NextButtonProps) {
  const location = useLocation();

  return (
    hasMore && (
      <div className="flex justify-center py-4" id="next-button">
        <a
          className={clsx(
            className,
            "bg-button-tertiary text-button-1 flex h-[32px] w-[101px] items-center justify-center rounded-full",
            loading && "pointer-events-none cursor-not-allowed!",
          )}
          href={`${location.pathname}?page=${currentPage + 1}`}
          onClick={(e) => {
            e.preventDefault();
            if (loading) return;
            onNext();
          }}
        >
          {text}
        </a>
      </div>
    )
  );
}
